<template>
  <div>
    <div v-show="!contacts.length">There are no contacts.</div>
    <div v-for="contact in contacts" :key="contact.siteContactId">
      <font-awesome-icon
        icon="trash"
        v-if="!opportunity && canEdit"
        class="delete-icon"
        v-b-tooltip.hover
        placement="left"
        title="Delete Contact"
        @click="openDeleteModal(contact)"
      />
      <strong>{{ contact.firstName }} {{ contact.lastName }}</strong>
      <span v-if="canEdit"
        >(<router-link
          :to="{
            name: 'editContact',
            params: { contactId: contact.siteContactId },
          }"
          >Edit</router-link
        >)</span
      ><br />
      <span class="contact-title">{{ contact.title }}</span
      ><br />
      <span class="contact-email">e: {{ contact.email }}</span
      ><br />
      <span class="contact-phone-number">p: {{ contact.phoneNumber }}</span
      ><br />
      <span class="contact-fax-number">f: {{ contact.faxNumber }}</span
      ><br />
      <span class="contact-address">{{ contact.address }}</span
      ><br />
      <span class="contact-address"
        >{{ contact.city }}, {{ contact.state }} {{ contact.zipCode }}</span
      >
      <br />
      <span class="contact-signer"
        >Authorized Signer: {{ contact.authorizedSigner | trueOrFalse }}</span
      ><br />
      <span class="contact-student-contact"
        >Placements Contact: {{ contact.studentContact | trueOrFalse }}</span
      ><br />
      <span class="contact-student-contact"
        >Site Supervisor: {{ contact.studentSupervisor | trueOrFalse }}</span
      ><br />
      <span
        >Last updated:
        {{
          (contact.modifiedDate ? contact.modifiedDate : contact.createdDate)
            | formatDate
        }}</span
      >
      <div class="separator bottom"></div>
    </div>

    <div class="align-right" v-if="!opportunity && canEdit">
      <b-button :to="{ name: 'addContact', params: { siteId: siteId } }"
        ><font-awesome-icon icon="plus" /> Add Contact</b-button
      >
    </div>

    <b-modal
      id="delete-contact-modal"
      title="Delete Site Contact"
      @ok="emitDelete(selectedContact)"
      v-model="showDeleteModal"
      v-if="selectedContact"
    >
      <p>Are you sure you would like to delete this site contact?</p>
      <div class="centered">
        <div class="inline-align-left">
          <span
            ><strong
              >{{ selectedContact.firstName }}
              {{ selectedContact.lastName }}</strong
            ></span
          ><br />
          <span class="contact-title">{{ selectedContact.title }}</span
          ><br />
          <span class="contact-email">e: {{ selectedContact.email }}</span
          ><br />
          <span class="contact-phone-number"
            >p: {{ selectedContact.phoneNumber }}</span
          ><br />
          <span class="contact-fax-number"
            >f: {{ selectedContact.faxNumber }}</span
          ><br />
          <span class="contact-address">{{ selectedContact.address }}</span
          ><br />
          <span class="contact-address"
            >{{ selectedContact.city }}, {{ selectedContact.state }}
            {{ selectedContact.zipCode }}</span
          >
          <br />
          <span class="contact-signer"
            >Authorized Signer:
            {{ selectedContact.authorizedSigner | trueOrFalse }}</span
          ><br />
          <span class="contact-student-contact"
            >Student Contact:
            {{ selectedContact.studentContact | trueOrFalse }}</span
          ><br />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      selectedContact: null,
      showDeleteModal: false,
    };
  },

  props: {
    contacts: {
      type: Array,
      required: true,
    },
    contractId: {
      required: false,
    },
    siteId: {
      required: false,
    },
    opportunity: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    canEdit: function () {
      if (this.opportunity) {
        return false;
      }
      // TODO: Replace with role-checks mixin, check for site manager role
      return _.find(this.user.userRoles, function (userRole) {
        return (
          userRole === "Placements.ContractManager" ||
          userRole === "Placements.Advisor"
        );
      });
    },
  },

  methods: {
    openDeleteModal(contact) {
      this.selectedContact = contact;
      this.showDeleteModal = true;
    },

    emitDelete: function (contact) {
      this.$emit("delete", contact);
    },
  },
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}

.align-right {
  text-align: right;
}

.delete-icon {
  margin-right: 5px;
}

.delete-icon:hover {
  color: red;
  cursor: pointer;
}

.centered {
  text-align: center;
}

.inline-align-left {
  display: inline-block;
  text-align: left;
}
</style>
